import { FC } from "react";
import { Icon } from "../../primitives";
import { TTabLinkIconProps } from "./Tabs.config";

export const TabLinkIcon: FC<TTabLinkIconProps> = ({ icon }) => (
  <div className="rounded-full flex justify-center items-center w-8 h-8 bg-black text-foreground-inverse">
    <Icon icon={icon} size="md" aria-hidden="true" />
  </div>
);
